// Inner bundle landing pages live under /dream-bundles/:slug. The hub itself
// is the "dream-bundles" LP, served by the generic /:slug route.
export const BUNDLES_HUB_PATH = '/dream-bundles';

// LPs that are only reachable as /dream-bundles/<slug>. Their old top-level
// URL (/<slug>) redirects there.
export const BUNDLE_SLUGS = [
  'thrill-pass',
  'splash-pass',
  'junior-adventure-pass',
  'adventure-day-pass',
  'glow-and-reflect-pass',
  'dreampass',
];

const slugPattern = BUNDLE_SLUGS.join('|');

export const BUNDLE_PAGE_PATH = `${BUNDLES_HUB_PATH}/:slug(${slugPattern})`;
export const LEGACY_BUNDLE_PATH = `/:slug(${slugPattern})`;

// Keeps query string and hash (UTMs, anchors) when redirecting.
export function getBundleRedirect(location) {
  return {
    ...location,
    pathname: `${BUNDLES_HUB_PATH}${location.pathname.toLowerCase()}`,
  };
}
